import { createReducer, on } from '@ngrx/store';
import * as StopShiftWizardActions from './stop-wizard.actions';
import {
  StepCashData,
  StepLotteryData,
  StepScratchData,
  StopWizardState,
} from '../models/stop-wizard.model';

const initialStepLottery: StepLotteryData = {
  lotteryCount: null,
  lotteryMatches: undefined,
  originalLotteryValue: null,
  derivedState: { canContinue: false },
};

const initialStepScratch: StepScratchData = {
  scratchData: [],
  ticketBatches: [],
  scratchMatches: undefined,
  originalScratchValue: null,
  derivedState: { canContinue: false },
};

const initialStepCash: StepCashData = {
  cashAmount: null,
  cashMatches: undefined,
  derivedState: { canContinue: false },
};

export const initialStopWizardState: StopWizardState = {
  stepLotteryData: { ...initialStepLottery },
  stepScratchData: { ...initialStepScratch },
  stepOcrData: [],
  stepCashData: { ...initialStepCash },
  derivedState: { complete: false },
};

export const stopWizardReducer = createReducer(
  initialStopWizardState,

  on(StopShiftWizardActions.setStopLotteryData, (state, { lotteryData }) => ({
    ...state,
    stepLotteryData: { ...state.stepLotteryData, ...lotteryData },
  })),

  on(StopShiftWizardActions.setStopScratchData, (state, { scratchData }) => ({
    ...state,
    stepScratchData: { ...state.stepScratchData, ...scratchData },
  })),

  on(StopShiftWizardActions.setStopOcrData, (state, { ocrData }) => ({
    ...state,
    stepOcrData: ocrData,
  })),

  on(StopShiftWizardActions.setStopCashData, (state, { cashData }) => ({
    ...state,
    stepCashData: { ...state.stepCashData, ...cashData },
  })),

  on(StopShiftWizardActions.resetStopWizard, () => initialStopWizardState)
);
